import React, { useState } from 'react';
import castArray from 'lodash/castArray';
import { useTranslation } from 'react-i18next';

import useFileUpload from '../hooks/useFileUpload';
import FormHttpBtn from './FormHttpBtn.jsx';
import FileClick from './FileClick.jsx';
import ModalAlert from './ModalAlert.jsx';

const FormHttpFileBtn = (props) => {
  const {
    api,
    children,
    className,
    icon,
    fileOpts,
    onSuccess,
    customErrorAlert,
  } = props;
  const [alert, setAlert] = useState(false);
  const [res, onFile] = useFileUpload({
    onSuccess,
    onError() {
      setAlert(true);
    },
  });
  const { t } = useTranslation();
  const CustomErrorAlert = customErrorAlert;

  return (
    <>
      <FormHttpBtn
        res={res}
        className={`position-relative ${className}`}
        icon={icon}
      >
        <FileClick
          {...fileOpts}
          onFile={(files) => onFile(api, files[0])}
        />
        {children}
      </FormHttpBtn>
      { alert && customErrorAlert && (
        <CustomErrorAlert 
          res={res} 
          show={alert} 
          onHide={() => setAlert(false)} 
        />
      )}
      { alert && !customErrorAlert && (
      <ModalAlert
        size="md"
        show={alert}
        onHide={() => setAlert(false)}
      >
        {res.status === 'error' && res.code === 400 && (
          <>
            <h1>{t('Upload Errors')}</h1>
            <div className="text-left">
              {castArray(res.payload).map((e, i) => (
                <div key={i}>
                  {e}
                </div>
              ))}
            </div>
          </>
        )}
      </ModalAlert>
      )}
    </>
  );
};

export default FormHttpFileBtn;
